import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${props => props.theme.mediaQueries.mediumDown} {
    flex-direction: column;
    align-items: center;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: ${props => props.theme.colors.capsuleGray10};
  margin: ${props => props.theme.space.s7} ${props => props.theme.space.none};
`;

export const EscriptCount = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;
`;

export const EscriptItem = styled.div`
  margin-bottom: ${props => props.theme.space.s3};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GreenLink = styled.a`
  background: transparent;
  border: none;
  color: ${props => props.theme.colors.capsuleGreen60};
  cursor: pointer;
  font-size: ${props => props.theme.fontSizes.body};
  outline: none;

  &:hover {
    text-decoration: underline;
  }

  & svg {
    fill: ${props => props.theme.colors.capsuleGreen60};
    height: ${props => props.theme.iconSizes.sm} !important;
    width: ${props => props.theme.iconSizes.sm} !important;
  }
`;

export const List = styled.div<{ hasMarginTop?: boolean }>`
  margin-top: ${props => (props.hasMarginTop ? props.theme.space.s7 : '')};
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.div<{ hasMarginBottom?: boolean }>`
  display: flex;
  flex-direction: row;
  line-height: ${props => props.theme.lineHeights.body};
  margin-bottom: ${props => (props.hasMarginBottom ? props.theme.space.s3 : '')};
`;

export const ListText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MedicationHeader = styled.h4`
  padding: 0 !important;
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  margin-bottom: ${props => props.theme.space.s5} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
`;

export const MedicationItem = styled.div`
  margin-bottom: ${props => props.theme.space.s3};
  display: flex;
  align-items: center;

  svg {
    fill: ${props => props.theme.colors.capsuleBlue50};
  }
`;

export const MedicationLabel = styled.span`
  margin-left: ${props => props.theme.space.s2};
  font-size: ${props => props.theme.fontSizes.body};
`;

export const Number = styled.div<{ isBold?: boolean }>`
  width: 1.4rem;
  margin-right: ${props => props.theme.space.s3};
  display: flex;
  justify-content: flex-end;
  font-weight: ${props => (props.isBold ? props.theme.fontWeights.bold : '')};
`;

export const SectionItem = styled.div<{ hasMarginBottom: boolean }>`
  margin-bottom: ${props => (props.hasMarginBottom ? props.theme.space.s3 : '')};
`;

export const SectionTitle = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.small};
  line-height: ${props => props.theme.lineHeights.body};
  letter-spacing: ${props => props.theme.letterSpacings.one};
  text-transform: uppercase;
  color: ${props => props.theme.colors.capsuleGray50};
  margin-bottom: ${props => props.theme.space.s2};
`;

export const SubHeader = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body};
  line-height: ${props => props.theme.lineHeights.body};
  color: #5d7896;
`;

export const SubHeaderEdu = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body};
  line-height: ${props => props.theme.lineHeights.body};
  color: ${props => props.theme.colors.capsuleBlue50};
`;

// Education Onboarding

export const EduButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.space.s7};

  ${props => props.theme.mediaQueries.medium} {
    flex-direction: row;
    padding-top: ${props => props.theme.space['7.2']};
  }
`;

export const EduIconContainer = styled.div`
  margin-right: ${props => props.theme.space.s4};

  svg {
    height: 49px;
    width: 32px;
  }
`;

export const EduNextBox = styled.div`
  align-items: center;
  border-radius: ${props => props.theme.radii.small};
  box-shadow: ${props => props.theme.shadows.dp2};
  display: flex;
  flex-direction: row;
  padding: ${props => props.theme.space.s4};
`;

export const EduSection = styled.div`
  padding-top: ${props => props.theme.space.s5};

  ${props => props.theme.mediaQueries.medium} {
    padding-top: ${props => props.theme.space.s7};
  }
`;

export const EduSectionTitle = styled.h4<{ smallPadding?: boolean }>`
  color: ${props => props.theme.colors.capsuleBlue50};
  font-size: ${props => props.theme.fontSizes.headerFour} !important;
  padding-bottom: ${props => (props.smallPadding ? props.theme.space.s2 : props.theme.space.s3)} !important;
  padding-top: ${props => props.theme.space.none} !important;
  margin-bottom: ${props => props.theme.space.none} !important;
`;

export const EduStyledButton = styled(Button)`
  margin: 0 !important;
  width: 100% !important;

  ${props => props.theme.mediaQueries.medium} {
    align-self: flex-start;
    width: 50% !important;
  }
`;

export const StyledTertiaryButton = styled(Button)`
  height: 100% !important;
  padding: 0 !important;
  margin: ${props => props.theme.space.s3} 0 0 !important;

  ${props => props.theme.mediaQueries.medium} {
    margin: 0 0 0 8.5rem !important;
  }
`;
